import { createDataModuleActions } from '@perpay-web/data-module/createDataModuleActions';

const dataModuleActions = createDataModuleActions(
    'FETCH_BORROWER_CREDIT_SUMMARY',
);
export const fetchBorrowerCreditSummary = dataModuleActions.dataRequest;
export const replaceBorrowerCreditSummary = dataModuleActions.dataSuccess;
export const setBorrowerCreditSummaryError = dataModuleActions.dataError;
export const resetBorrowerCreditSummary = dataModuleActions.dataReset;
